import { useTranslation } from 'react-i18next';

import { DateRange } from 'utils/misc';
import colorsStore from 'shared/store/colorsStore';

import { MappedHistoryItem } from 'types/AssistantTypes';
import { HistoryItem } from './components/HistoryItem';

type ThreadListProps = {
  range: DateRange;
  threads: MappedHistoryItem[];
  onThreadDelete?: (threadId: string) => void;
  sizeExpanded: number;
};

export const ThreadList: React.FC<ThreadListProps> = ({ range, threads, onThreadDelete, sizeExpanded }) => {
  const colorsConfig = colorsStore((state) => state.colorsConfigStore);
  const { t } = useTranslation();
  if (!threads.length) return;

  return (
    <div className="overflow-hidden text-ellipsis whitespace-nowrap">
      <div className="mb-2 text-xs font-bold" style={{ fontSize: 12, color: colorsConfig.finecoBluePrimary }}>
        {t(`assistant.dateRange.${range}`)}
      </div>
      {threads.map((thread) => (
        <HistoryItem key={thread.id} thread={thread} onThreadDelete={onThreadDelete} sizeExpanded={sizeExpanded} />
      ))}
    </div>
  );
};
